import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-folder-star-icon',
  templateUrl: './files-folder-star.component.html'
})
export class FilesFolderStarComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
